import React, { useEffect, useState } from 'react'
import fire from './Firebase'
import macpicurl from './assets/macbook.png'
import { FaRegHandshake } from 'react-icons/fa'

function About(props) {
    const themeColors = props.themeColors
    const darkMode = props.darkMode
    // const [macpicurl, setmacpicurl] = useState('')
    // useEffect(() => {
    //     fire.storage().ref('assets/macbookpro13.png').getDownloadURL().then((url) => {
    //         setmacpicurl(url)
    //     })
    // })
    return (
        <div style={{ flex: 1, overflow: 'auto', height: 'auto' }}>
            <div style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, maxHeight: '100%', marginBottom: 5, marginTop: 2 }}>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', paddingLeft: 3, flexDirection: 'column', padding: 10 }}>
                    {/* <p style={{margin: 0}}>Hi, My name is <strong>Brahm Harsh Parmar</strong></p><br></br> */}
                    <p style={{ margin: 0, margin: "5px 0" }}>
                        I'm a Full Stack Developer at a Spain-based game development company. I'm a passionate coder who loves working with open source technologies and the web platform. With over 5 years of experience in web development, I started my career as a system engineer, where I gained knowledge in networking. Later, I made the decision to transition into a Full Stack Developer role, quit my job, and began learning to code. JavaScript was my first language, and I've since worked with frameworks such as React JS, React Native, Node JS, and Capacitor JS. I've successfully contributed to various projects, including web development, mobile applications, and automation. Tap on the 'Work' section to see them and feel free to contact me.
                    </p>
                </div>
            </div>
            <div>
                <p><span style={{ marginRight: 5 }}>&#9679;</span>My Workstation</p>
                <div style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: '100%', marginBottom: 5, marginTop: 5, padding: 5, alignItems: 'center', justifyContent: 'center', paddingTop: 15, paddingBottom: 15 }}>
                    <img src={macpicurl} style={{ height: 75 }} alt='' />
                    <p style={{ marginLeft: 15 }}>Apple MacBook Pro<br /><span className='smallTxt' style={{ fontSize: 11, color: darkMode ? themeColors.darkOn.textColor1 : themeColors.darkOff.textColor1, textAlign: 'center' }}>13 (M1 Chip, Late 2020)</span></p>
                </div>
            </div>
            <div onClick={props.hirebtn} style={{ display: 'flex', backgroundColor: darkMode ? themeColors.darkOn.container.secondary : themeColors.darkOff.container.secondary, height: 40, marginBottom: 5, marginTop: 10, padding: 5, alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                <FaRegHandshake style={{ fontSize: 25, marginRight: 10 }} />
                <p>Hire Me</p>
            </div>
        </div>
    )
}

export default About